export default __webpack_public_path__ + "static/media/alice-home-title.daa9b562.svg";